module.exports = __webpack_public_path__ + "static/img/partner-title.cfcf1a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner/partner-title.png
// module id = VBo9
// module chunks = 1